import type { ReactNode } from "react"
import { memo } from "react"

import { cn } from "@productlane/lib/src/cn"

/** The page a tab opens on (the docs home, an API overview), pinned above its groups. */
export const NavLandingRow = memo(
	({
		icon,
		label,
		isActive,
		onClick,
		className,
	}: {
		icon: ReactNode
		label: string
		isActive: boolean
		onClick: () => void
		className?: string
	}) => (
		<button
			type="button"
			onClick={onClick}
			aria-current={isActive ? "page" : undefined}
			className={cn(
				"flex h-[1.9rem] w-full min-w-0 cursor-default select-none items-center gap-2 rounded-md pl-2 pr-1 text-left text-sm font-medium",
				isActive
					? "bg-gray-100 text-primary dark:bg-gray-800"
					: "text-secondary hover:bg-gray-100 hover:text-primary dark:hover:bg-gray-800/50",
				className,
			)}
		>
			{icon}
			<span className="truncate">{label}</span>
		</button>
	),
)
